import request from '@/utils/request'

//根据字典类型code值、字典名称查询字典集合
export function getDictByCode(data) {
	return request({
		url: '/api/dictItem/getDictByCode',
		method: 'get',
		params: data
	})
}
